export default __webpack_public_path__ + "static/media/annoucement-horn-and-bubbles.e5c68645.svg";